import React, { useState, useRef, useEffect } from "react";
import GoogleMapReact from 'google-map-react';
import useSupercluster from "use-supercluster";

import { ClusterMarker, UserMarker } from "./markers";

import { fetchDocuments, zoomToPrecisionLevel } from "../model/utils";

export default props => {
    // Get user's current location
    //navigator.geolocation.getCurrentPosition(coords => setDefaultCenter(coords.coords))
    // Default zoom of map, higher = more zoomed in
    const defaultZoom = 5

    const [serverClusters, setServerClusters] = useState([])
    const [users, setUsers] = useState([])
    const [defaultCenter] = useState({lat:33.901340,lng:-118.387460})
    const [bounds, setBounds] = useState([])
    const [zoom, setZoom] = useState(defaultZoom)

    const mapRef = useRef();

    const { clusters } = useSupercluster({
        points: users,
        bounds,
        zoom,
        options: { radius: 100, maxZoom: 20 }
    });

    const loadPoints = async ({ zoom, bounds }) => {        
        // Set state of map to reflect the change
        setBounds([
            bounds.nw.lng,
            bounds.se.lat,
            bounds.se.lng,
            bounds.nw.lat
        ])
        setZoom(zoom)
        
        const precision = zoomToPrecisionLevel(zoom)
        const { type, data } = await fetchDocuments(props.searchOptions, precision, bounds.nw, bounds.se)
        if (type === "Users") {
            setUsers(data ? data : [])
            setServerClusters([])
        } else {
            setServerClusters(data ? data : [])
            setUsers([])
        }   
    }

    useEffect(() => {
        async function _() {
            if (bounds.length === 0) {
                //console.log("not loaded")
            } else {
                //console.log(bounds)
                const precision = zoomToPrecisionLevel(zoom)
                const docs = await fetchDocuments(props.searchOptions, precision, {lat: bounds[3], lng: bounds[0]}, {lat: bounds[1], lng: bounds[2]})
                if (docs.type === "Users") {
                    setUsers(docs.data)
                    setServerClusters([])
                } else {
                    setServerClusters(docs.data)
                    setUsers([])
                }   
            }        
        }
        _()
    }, [props.searchOptions])

    return (
        <div style={{ height: '100vh', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: props.googleMapKey }}
                // center={defaultCenter}
                defaultCenter={defaultCenter}
                defaultZoom={defaultZoom}
                defaultOptions={{zoomControl: false}}
                // yesIWantToUseGoogleMapApiInternals={true}
                onGoogleApiLoaded={({ map }) => {
                    mapRef.current = map;
                    console.log("Map Loaded")
                }}
                // Called on load + every movement like zoom or pan
                onChange={loadPoints}               
            >
                {
                    // Map clusters of users generated by Supercluster
                    clusters.map((cluster, i) => {
                        if (cluster.properties.cluster) {
                            return <ClusterMarker
                                key={i}
                                text={ cluster.properties.point_count }
                                lat={ cluster.geometry.coordinates[1] }
                                lng={ cluster.geometry.coordinates[0] }
                            />
                        } else {
                    // If not a cluster then just the user marker    
                            let properties = cluster.properties
                            return <UserMarker 
                                key={i}
                                name={properties.name}
                                forMap
                                text={ properties.name ? properties.name : properties.name }
                                lat={ cluster.geometry.coordinates[1] }
                                lng={ cluster.geometry.coordinates[0] }
                                onTap={() => props.updateCallout({
                                    name: properties.name, 
                                    tags: properties.tags, 
                                    imageURL: properties.imageURL,
                                    createdAt: properties.createdAt,
                                    profileId: properties.profileId,
                                    tagFeatured: properties.tagFeatured
                                })}
                        />
                        }
                    })
                } 
                {
                    serverClusters.map((cluster, i) => (
                        <ClusterMarker 
                            key={ i }
                            text={ cluster.count } 
                            lat={ cluster.location.lat }
                            lng={ cluster.location.lon }
                        />
                    ))
                }
            </GoogleMapReact>
        </div>
    )
}